import { createTheme, globalTheme } from '@clds/component-theme';

export const theme = createTheme({
  background: globalTheme.palette.surface,
  color: globalTheme.palette.contrastHigh,
  radius: globalTheme.radius.lg,
  dangerColor: globalTheme.palette.errorAlt,
  successColor: globalTheme.palette.success,
  disabledColor: globalTheme.palette.secondaryAlt,
  minHeight: '110px',
  verticalSpacing: '6px',
  onPhone: {
    minHeight: '375px',
  },
  avatarSkeleton: {
    onPhone: {
      width: '192px',
      height: '192px',
    },
  },
  imageWrapper: {
    width: '110px',
    height: '110px',
    onPhone: {
      width: '200px',
      height: '200px',
    },
  },
  image: {
    radius: globalTheme.radius.lg,
  },
  listItem: {
    height: '40px',
    minWidth: '330px',
    spacing: globalTheme.spacing.xs,
  },
});
